export default __webpack_public_path__ + "img/decouvrez-homepage.3a122fec.svg";